import { minPurchaseCondition, multipleRedemptionCondition } from "../../utils";
import { useState } from "react";
import { Collapse } from "react-bootstrap";
import Typography from "../../../../../common/Typography";
import ChevronDown from "../../../../../assets/ChevronDown";

const BenefitConditions = ({ reward, currencyView }) => {
  const [isCondtionAccordionOpen, toggleConditionAccordion] = useState(false);
  const showMinBillCondition =
    reward?.settings?.min_bill_for_redemption?.active &&
    reward?.settings?.min_bill_for_redemption?.amount;

  const showMultipleRedemptionCondition =
    reward?.redemption?.mode === "multiple" &&
    reward?.redemption?.frequency?.period;

  return !showMinBillCondition && !showMultipleRedemptionCondition ? (
    <></>
  ) : (
    <div className="benefit-conditions">
        <div
          className="conditions-head"
          onClick={() => toggleConditionAccordion(!isCondtionAccordionOpen)}
        >
          <Typography size="text-md" customClass="conditions-head-text">
            Conditions
          </Typography>
          <ChevronDown
            width={20}
            height={20}
            color={"#697777"}
            rotate={isCondtionAccordionOpen ? 180 : 0}
          />
        </div>
        <Collapse in={isCondtionAccordionOpen}>
          <div className="conditions-list">
            {showMultipleRedemptionCondition && (
              <Typography size="text-sm" customClass="condition-text">
                {multipleRedemptionCondition.replace(
                  "{{period}}",
                  reward?.redemption?.frequency?.period?.slice(0, -1)
                )}
              </Typography>
            )}
            {showMinBillCondition && (
              <Typography size="text-sm" customClass="condition-text">
                {minPurchaseCondition.replace(
                  "{{min_bill_amount}}",
                  `${currencyView}${reward?.settings?.min_bill_for_redemption?.amount}`
                )}
              </Typography>
            )}
          </div>
        </Collapse>
    </div>
  );
};

export default BenefitConditions;
